import { actions } from '../actions';
import _ from 'lodash';
import { getParsedToken } from 'common/services/token.service';

const initialState = [];

export const accountReducer = (state = initialState, action) => {
  const parsedToken = getParsedToken();
  switch (action.type) {
    case actions.GET_ACCOUNT_SUCCEED: {
      const otherAccounts = !_.isEmpty(parsedToken)
        ? state.filter(account => account.id !== parsedToken.id * 1)
        : state;
      return [...otherAccounts, action.payload];
    }
    case actions.UPDATE_ACCOUNT_SUCCEED: {
      return state.map(account =>
        account.id === action.payload.id ? action.payload : account
      );
    }
    case actions.CREATE_ORGANIZATION_SUCCEED: {
      const myAccount = !_.isEmpty(parsedToken)
        ? state.find(account => account.id === parsedToken.id * 1)
        : null;
      const otherAccounts = !_.isEmpty(parsedToken)
        ? state.filter(account => account.id !== parsedToken.id * 1)
        : state;
      return [
        ...otherAccounts,
        {
          ...myAccount,
          organization_id: action.payload.id
        }
      ];
    }
    case actions.GET_ACCOUNTS_SUCCEED: {
      const myAccount = !_.isEmpty(parsedToken)
        ? state.find(account => account.id === parsedToken.id * 1)
        : null;
      const allAccountsWithoutMyAccount = !_.isEmpty(parsedToken)
        ? action.payload.filter(account => account.id !== parsedToken.id * 1)
        : action.payload;
      return [myAccount, ...allAccountsWithoutMyAccount].filter(Boolean);
    }
    case actions.DESTROY_ACCOUNT_SUCCEED:
      return state.filter(a => a.id !== action.payload.id);
    default:
      return state;
  }
};
